<template>
  <div class="my_line_style_index">
    <p :class="type == 'one_level' ? 'set_one_level': 'set_two_level'">
      <span v-text="title" class="title" :style="{width: titleWidth + 'px'}"></span>
      <el-select
        class="module"
        v-model="Result"
        popper-class="line_select_style"
        :placeholder="placeholder"
        :disabled="disabled"
        size="small"
        @change="change"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
    </p>
  </div>
</template>

<script>
export default {
  name: 'my_line_style_index',
  props: {
    titleWidth: {
      type: String,
      default: '40'
    },
    title: { // 组件的标题
      type: String,
      default: ''
    },
    type: { // 组件的类型  one_level 一级组件 two_level 二级组件
      type: String,
      default: 'two_level'
    },
    value: { // 输入框的值
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: { // 数组
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data () {
    return {
      Result: this.value
    }
  },
  mounted () {
  },
  watch: {
    Result (val) {
      this.$emit('update:value', val);//双向数据绑定
    },
    value (val) {
      this.Result = this.value
    }
  },
  computed: {
  },
  methods: {
    change () {
      this.$emit('change', this.Result);
    }
  }
}
</script>

<style scoped>
.module {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/my_line_style/index.vue